import { DatePipe } from '@angular/common';
import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { UserService } from 'src/app/services/user/user.service';
import { MbscDatetimeOptions, mobiscroll } from '@mobiscroll/angular';
import { ComercioActivoService } from 'src/app/services/merchant/comercio-activo.service';
import { productoPorOmision } from './producto-por-omision';

mobiscroll.settings = {
  lang: 'es',
  theme: 'ios',
  themeVariant: 'light',
};

const now = new Date();

//const week = [ new Date(now.getFullYear(),0, 1),now];
let week = [ new Date() ,new Date()];


@Component({
  selector: 'app-dashboard-invice',
  templateUrl: './dashboard-invice.component.html',
  styleUrls: ['./dashboard-invice.component.css'],
  providers: [DatePipe]

})
export class DashboardInviceComponent implements OnInit {

  loading:any;
  shop:any;
  stadistic:any;
  shops:any;
  shops_obj:any;

  // === FILTRO MÚLTIPLE DE PRODUCTOS - Propiedades ===
  productArray: any[] = [];
  selectedProducts: string[] = ['CREDIT']; // Productos seleccionados (estado final)
  showDropdown: boolean = false; // Visibilidad del dropdown
  tempSelectedProducts: string[] = ['CREDIT']; // Productos temporales (antes de aplicar)

  // === SISTEMA DE ESTADOS PROFESIONAL ===
  filterStates = {
    isLoadingProducts: false,    // Cargando lista de productos
    isApplyingFilter: false,     // Aplicando filtro seleccionado
    isLoadingResults: false,     // Cargando resultados de estadísticas
    hasError: false,             // Estado de error
    errorMessage: '',            // Mensaje de error específico
    isInitialized: false         // Si el filtro ya se inicializó
  };

  // Estados de animación
  dropdownAnimation = {
    isOpening: false,
    isClosing: false
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    private elementRef: ElementRef,
    private _comercioActivo: ComercioActivoService
  ) { }

 range: Array < Date > = week;
 date: Array < Date > = [];
 nonForm: Array < Date > = [];
 external = week;
 d1:any;
 d2:any;

 dateSetting3: MbscDatetimeOptions = {
   lang: 'es',
   theme: 'ios',
   themeVariant: 'light',
   max:now,
   responsive: {
     small: {
         controls: ['calendar'],
         display: 'center'
     },
     medium: {
         display: 'bubble',
     }
 }

 };

 birthday = new Date();
date_base: any = new Date;
date_base_string :any;

mobileSettings: MbscDatetimeOptions = {
 display: 'bottom',
 themeVariant: 'dark',
};


desktopSettings: MbscDatetimeOptions = {
 display: 'bubble',
 touchUi: false
};



  ngOnInit(): void {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');

    // Con una aseguradora arriba se abre en SU producto, no en CREDIT (ver producto-por-omision.ts).
    // Cambiar de comercio recarga la página, así que basta con decidirlo aquí.
    this.productoInicial = productoPorOmision(this._comercioActivo.codigo);
    this.selectedProducts = [this.productoInicial];
    this.tempSelectedProducts = [this.productoInicial];
    this.productSearchTerm = this.productoInicial;

    this.getshops();
    this.stadisticGet();
    this.initializeProductFilter();
  }

  /** El producto con que abre la pantalla: CREDIT, o el de la aseguradora activa. */
  productoInicial: string = 'CREDIT';


  stadisticGet = async () => {
    try {
      this.loading = true;

      let query =  {
        init:this.d1,
        end:this.d2,
        arr_typeProduct: this.selectedProducts // Enviar array de productos seleccionados
      };

      const resp = await this.getStadisticServer(query);

      this.stadistic = resp?.res;


    } catch (error) {
      console.error(error);



    }
    this.loading = false;




  }



  getStadisticServer = async (query:any) => {
    try{
        return this._user.getstadistic_invice_status(query);

      } catch (error) {
        console.error(error);


      }
  }


getshops = async () => {
  try {


    const resp = await this.getshopsServer();
    this.shops = resp?.res;

    let shops_resp = resp?.res;
    let shops:any = {};


    shops_resp.map((value:any)=>{

      shops[value.code] = value?.name;

    });

    this.shops_obj = shops;


  } catch (error) {
    console.error(error);

  }




}


getshopsServer = async () => {
  try{
      return this._user.getshops();

    } catch (error) {
      console.error(error);


    }
}


birthdaySet() {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    this.stadisticGet();

}

setNavigationFlag() {
  // Set flag in sessionStorage to indicate this is a programmatic navigation
  sessionStorage.setItem('dateFilterNavigation', 'true');
}

// === INICIALIZACIÓN DEL FILTRO DE PRODUCTOS ===
async initializeProductFilter() {
  await this.consultAllProductsInvoices();
  // 💎 Actualizar el término de búsqueda con el filtro por defecto (CREDIT)
  this.updateSearchTermFromSelection();
}

// === CARGA INICIAL DE PRODUCTOS ===
async consultAllProductsInvoices(){
  try {
    this.filterStates.isLoadingProducts = true;
    this.filterStates.hasError = false;

    let consultProducts = await this._user.getTypesProductsInvoices();

    // Verificar que la respuesta sea válida
    if (consultProducts && consultProducts.resp && Array.isArray(consultProducts.resp)) {
      this.productArray = consultProducts.resp;
      // Si el producto de la aseguradora no está en el catálogo, se vuelve a CREDIT y se recalcula.
      const inicial = productoPorOmision(this._comercioActivo.codigo, this.productArray);
      if (inicial !== this.productoInicial) {
        this.productoInicial = inicial;
        this.selectedProducts = [inicial];
        this.stadisticGet();
      }
      this.filteredProductArray = [...this.productArray]; // Inicializar array filtrado
      this.tempSelectedProducts = [...this.selectedProducts]; // Inicializar temp
      this.filterStates.isInitialized = true;
    } else {
      this.productArray = [{ params: { code: 'CREDIT' } }]; // Fallback básico
      this.filteredProductArray = [...this.productArray];
      this.tempSelectedProducts = ['CREDIT'];
      this.filterStates.isInitialized = true;
    }

  } catch (error) {
    console.error('❌ ERROR: Error al cargar productos:', error);
    // No mostrar error al usuario, solo usar fallback
    this.productArray = [{ params: { code: 'CREDIT' } }]; // Fallback básico
    this.filteredProductArray = [...this.productArray];
    this.tempSelectedProducts = ['CREDIT'];
    this.selectedProducts = ['CREDIT'];
    this.filterStates.isInitialized = true;
    // No establecer hasError = true para evitar la alerta
  } finally {
    this.filterStates.isLoadingProducts = false;
  }
}

// === MANEJO PROFESIONAL DEL DROPDOWN ===
async toggleDropdown() {
  if (this.showDropdown) {
    this.closeDropdown();
  } else {
    this.openDropdown();
  }
}

async openDropdown() {
  if (this.filterStates.isLoadingProducts) return;

  // Sincronizar tempSelectedProducts con selectedProducts al abrir
  this.tempSelectedProducts = [...this.selectedProducts];
  console.log('🔄 Abriendo dropdown - tempSelectedProducts:', this.tempSelectedProducts);
  console.log('🔄 Abriendo dropdown - selectedProducts:', this.selectedProducts);

  this.dropdownAnimation.isOpening = true;
  
  // Inicializar array filtrado si no hay búsqueda
  if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
    this.filteredProductArray = [...this.productArray];
  }

  // Pequeño delay para la animación
  setTimeout(() => {
    this.showDropdown = true;
    this.dropdownAnimation.isOpening = false;
  }, 50);
}

async closeDropdown() {
  this.dropdownAnimation.isClosing = true;

  setTimeout(() => {
    this.showDropdown = false;
    this.dropdownAnimation.isClosing = false;
    // Restaurar selección temporal si no se aplicó
    this.tempSelectedProducts = [...this.selectedProducts];
  }, 150);
}

// Detectar clics fuera del componente para cerrar el dropdown
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  if (this.showDropdown) {
    const productSearchContainer = this.elementRef.nativeElement.querySelector('.product-search-input');
    if (productSearchContainer) {
      const clickedInside = productSearchContainer.contains(event.target as Node);
      if (!clickedInside) {
        this.closeDropdown();
      }
    }
  }
}

// === MANEJO INTELIGENTE DE SELECCIÓN (MÚLTIPLE - mantener checkboxes funcionales) ===
onProductSelectionChange(productCode: string, isChecked: boolean) {
  try {
    if (isChecked) {
      // Agregar producto si no está ya seleccionado
      if (!this.tempSelectedProducts.includes(productCode)) {
        this.tempSelectedProducts.push(productCode);
      }
    } else {
      // Remover producto de la selección
      this.tempSelectedProducts = this.tempSelectedProducts.filter(code => code !== productCode);
    }

    // Si no hay productos seleccionados, se vuelve al producto con que abrió la pantalla
    if (this.tempSelectedProducts.length === 0) {
      this.tempSelectedProducts = [this.productoInicial];
    }

    // Actualizar el término de búsqueda inmediatamente para reflejar la selección
    this.updateSearchTermFromTempSelection();

    console.log('🔄 DEBUG: Productos temporales seleccionados:', this.tempSelectedProducts);
  } catch (error) {
    console.error('❌ ERROR en selección:', error);
  }
}

// Actualizar el término de búsqueda basado en la selección temporal
updateSearchTermFromTempSelection() {
  if (this.tempSelectedProducts.length === 0) {
    this.productSearchTerm = '';
  } else if (this.tempSelectedProducts.length === 1) {
    this.productSearchTerm = this.tempSelectedProducts[0];
  } else if (this.tempSelectedProducts.length === 2) {
    this.productSearchTerm = `${this.tempSelectedProducts[0]} y ${this.tempSelectedProducts[1]}`;
  } else {
    this.productSearchTerm = `${this.tempSelectedProducts.length} productos seleccionados`;
  }
}

// === APLICACIÓN PROFESIONAL DE FILTROS ===
async applyFilters(updateSearchTerm: boolean = true) {
  try {
    this.filterStates.isApplyingFilter = true;
    this.filterStates.isLoadingResults = true;
    this.filterStates.hasError = false;

    // Confirmar selección
    this.selectedProducts = [...this.tempSelectedProducts];

    // Actualizar la barra de búsqueda con el texto de los productos seleccionados (solo si se solicita)
    if (updateSearchTerm) {
      this.updateSearchTermFromSelection();
    }

    // Animación de cierre suave
    await this.closeDropdown();

    // Ejecutar consulta con feedback visual
    await this.stadisticGet();

  } catch (error) {
    console.error('❌ ERROR al aplicar filtros:', error);
    // Solo mostrar error si es crítico, de lo contrario usar valores por defecto
    if (!this.stadistic) {
      this.filterStates.hasError = true;
      this.filterStates.errorMessage = 'Error al cargar estadísticas';
    }
  } finally {
    this.filterStates.isApplyingFilter = false;
    this.filterStates.isLoadingResults = false;
  }
}

// === FUNCIONES DE UTILIDAD MEJORADAS ===
isProductSelected(productCode: string): boolean {
  return this.tempSelectedProducts.includes(productCode);
}

getSelectedProductsText(): string {
  const count = this.selectedProducts.length;

  if (count === 0) {
    return 'Seleccionar productos...';
  }
  if (count === 1) {
    return this.selectedProducts[0];
  }
  if (count === 2) {
    return `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
  }
  return `${count} productos seleccionados`;
}

async clearAllFilters() {
  this.tempSelectedProducts = [this.productoInicial];
  this.selectedProducts = [this.productoInicial];
  this.updateSearchTermFromSelection();

  try {
    this.filterStates.isLoadingResults = true;
    await this.stadisticGet();
  } catch (error) {
    console.error('❌ ERROR al limpiar filtros:', error);
    // No mostrar error al usuario, los datos originales permanecen
  } finally {
    this.filterStates.isLoadingResults = false;
  }
}

// === FUNCIÓN DE RETRY PARA ERRORES ===
async retryOperation() {
  this.filterStates.hasError = false;
  this.filterStates.errorMessage = '';

  try {
    if (!this.filterStates.isInitialized) {
      await this.consultAllProductsInvoices();
    } else {
      await this.applyFilters();
    }
  } catch (error) {
    console.error('❌ ERROR en retry:', error);
    // Si el retry falla, ocultar el error y usar estado básico
    this.filterStates.hasError = false;
    this.filterStates.errorMessage = '';
  }
}

// === FUNCIONES DE OPTIMIZACIÓN ===
trackByProductCode(index: number, item: any): string {
  return item?.params?.code || index;
}

// 💎 BÚSQUEDA DE PRODUCTOS - Propiedades y Métodos
productSearchTerm: string = 'CREDIT'; // Inicializar con CREDIT por defecto
filteredProductArray: any[] = [];

// Filtrar productos por búsqueda
filterProductsSearch() {
  if (!this.productArray) {
    this.filteredProductArray = [];
    return;
  }

  if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
    this.filteredProductArray = [...this.productArray];
    return;
  }

  const term = this.productSearchTerm.toLowerCase().trim();
  this.filteredProductArray = this.productArray.filter((product: any) => {
    return (
      product?.params?.name?.toLowerCase().includes(term) ||
      product?.params?.code?.toLowerCase().includes(term) ||
      (product?.params?.dinamic_code && 
       product.params.dinamic_code.some((code: string) => code.toLowerCase().includes(term)))
    );
  });

  console.log('🔍 Productos filtrados:', this.filteredProductArray.length);
}

// Limpiar búsqueda de productos (solo limpia el texto, no la selección)
async clearProductSearch() {
  // Solo limpiar el término de búsqueda visual
  this.productSearchTerm = '';
  this.filteredProductArray = [...this.productArray];
  
  // NO resetear la selección - mantener los productos seleccionados actuales
  // El usuario puede escribir para buscar otro producto
}

// Actualizar el término de búsqueda con los productos seleccionados
updateSearchTermFromSelection() {
  if (this.selectedProducts.length === 0) {
    this.productSearchTerm = '';
  } else if (this.selectedProducts.length === 1) {
    // Un solo producto: mostrar su código
    this.productSearchTerm = this.selectedProducts[0];
  } else if (this.selectedProducts.length === 2) {
    // Dos productos: mostrar ambos códigos separados por "y"
    this.productSearchTerm = `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
  } else {
    // Más de 2 productos: mostrar resumen
    this.productSearchTerm = `${this.selectedProducts.length} productos seleccionados`;
  }
  
  console.log('🔍 Término de búsqueda actualizado:', this.productSearchTerm);
}

// === MÉTODO LEGACY ADAPTADO ===
async setCodeTypeProduct(event:any){
  try {
    const selectedValue = event.target.value;

    // Actualizar filtro con selección única
    this.selectedProducts = [selectedValue];
    this.tempSelectedProducts = [selectedValue];

    let query = {
      init:this.d1,
      end:this.d2,
      arr_typeProduct: this.selectedProducts
    };

    const resp = await this.getStadisticServer(query);
    this.stadistic = resp?.res;

  } catch (error) {
    throw error;
  }
}

}
